const transactionConstant = {
  ADD_POINT: 'ADD_POINT',
  CANCEL_ADD_POINT: 'CANCEL_ADD_POINT',
  USE_POINT: 'USE_POINT',
  CANCEL_USE_POINT: 'CANCEL_USE_POINT',
  TYPE_TO_DISPLAY_AMOUNT: [
    'ADD_POINT', 'CANCEL_ADD_POINT',
  ],
  STATUS_INITIAL: 'INITIAL',
  STATUS_SYNCED: 'SYNCED',
  STATUS_CANCELED: 'CANCELED',
  STATUS_IGNORED: 'IGNORED',

  limit: {
    MIN_AMOUNT: 0,
    MAX_AMOUNT: 99999999,
    MIN_TOTAL_ADD_POINT: 1,
  },

  getPromotions: {
    // backoff delay before retrying after a failed attempt
    RETRY_INTERVAL_MS: 1500,
    MAX_RETRY: 2,
    // hard deadline for the whole flow (all attempts + backoff delays combined),
    // counted from the moment the screen starts loading promotions
    TOTAL_TIMEOUT_MS: 20000,
  },
};

export default transactionConstant;
